export const fetchEmployees = async (apiUrl) => {
    try {
        const response = await fetch(`${apiUrl}/fetch_employees`, {
            method: 'GET', 
            headers: {
                'Content-Type': 'application/json',
                "Access-Control-Allow-Credentials": true,
                
            },
            credentials:"include",
        });
        if (!response.ok) 
            throw new Error("Failed to fetch employee data");
        
        const data = await response.json();
        return data;
            
    } catch (error) {
        console.error("Error fetching employees:", error);
        return { error: error.message };  
    }
};

// export const addEmployee = async (apiUrl, formData, Address, isEditing, selectedEmployee) => {
//     const url = isEditing
//         ? `${apiUrl}/update_employee/${selectedEmployee}`
//         : `${apiUrl}/add_employee`;
//     const method = isEditing ? "PUT" : "POST";

//     try {
//         const response = await fetch(url, {
//             method,
//             headers: { 
//                 "Content-Type": "application/json" ,
//                 "Access-Control-Allow-Credentials": true,
//             },
//             body: JSON.stringify(formData),
//             credentials:"include",
//         });
//         if (!response.ok) 
//             throw new Error("Failed to save employee");

//         const data = await response.json();
//         return data;

//     } catch (error) {
//         console.error("Error saving employee:", error);
//         return { error: error.message };  
//     }
// };

export const addEmployee = async (apiUrl, formData) => {
    // const url = `${apiUrl}/add_employee`;
    try {
        const response = await fetch(`${apiUrl}/add_employee`, {
            method: "POST",
            headers: { 
                "Content-Type": "application/json" ,
                "Access-Control-Allow-Credentials": true,
            },
            body: JSON.stringify(formData),
            credentials: "include",
        });
        
        if (!response.ok) 
            throw new Error("Failed to add employee");

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error adding employee:", error);
        return { error: error.message };  
    }
}


// export const updateEmployee = async (apiUrl, formData, selectedEmployee, Address) => {
//     // const url = `${apiUrl}/update_employee/${selectedEmployee}`;
//     try {
//         const response = await fetch(`${apiUrl}/update_employee/${selectedEmployee}`, {
//             method: "PUT",
//             headers: { 
//                 "Content-Type": "application/json" ,
//                 "Access-Control-Allow-Credentials": true,
//             },
//             body: JSON.stringify(Address),
//             credentials: "include",
//         });
        
//         if (!response.ok) 
//             throw new Error("Failed to update employee");

//         const data = await response.json();
//         return data;
//     } catch (error) {
//         console.error("Error updating employee:", error);
//         return { error: error.message };  
//     }
// };

export const updateEmployee = async (apiUrl, updatedEmployee, selectedEmployee) => {
    try {
        const response = await fetch(`${apiUrl}/update_employee/${selectedEmployee}`, {
            method: "PUT",
            headers: { 
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": true,
            },
            body: JSON.stringify(updatedEmployee),  // Pass the entire updated employee object
            credentials: "include",
        });

        if (!response.ok) 
            throw new Error("Failed to update employee");

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error updating employee:", error);
        return { error: error.message };  
    }
};


export const deleteEmployee = async (apiUrl, selectedEmployee) => {
    if (!selectedEmployee) {
        alert("Please select an employee to delete.");
        return;
    }

    try {
        const response = await fetch(`${apiUrl}/delete_employee/${selectedEmployee}`, {
            method: "DELETE",
            headers: { 
                "Content-Type": "application/json" ,
                "Access-Control-Allow-Credentials": true,
            },
            credentials:"include",
        });
        if (!response.ok) 
            throw new Error("Failed to delete employee");

        const data = await response.json();
        return data;
        
    } catch (error) {
        console.error("Error deleting employee:", error);
        return { error: error.message };  
    }
};

export const fetchEmployeesByPage = async (apiUrl, pageNo, pageSize, sortColumn, sortOrder) => {
    const requestData = {
      page_no: pageNo,
      page_size: pageSize,
      sort_column: sortColumn,
      sort_order: sortOrder,
    };
  
    try {
      const response = await fetch(`${apiUrl}/fetch_employees_by_page`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestData),
      });
  
      if (!response.ok) {
        throw new Error('Error fetching employees');
      }
  
      const data = await response.json();
  
      if (data && data.employee_list) {
        // Ensure the correct employee data is returned
        return {
          employee_list: data.employee_list,
          total_pages: data.total_pages, // Total pages from the API response
          total_count: data.total_count, // Total records (13 in your case)
        };
      } else {
        throw new Error("Invalid data format from the API.");
      }
    } catch (error) {
      console.error('Error fetching employees:', error);
      return { employee_list: [], total_pages: 0, total_count: 0 }; // Fallback
    }
};